export const WORKSHOP_CONST = 'WORKSHOP'
export const USER_RESPONSE_KEY = 'userResponse'
export const SUCCESS_CODE = 200
export const CDN_URL = 'https://d2lybwojpmsvj1.cloudfront.net'

export const SERVICE_MAP = {
  WORKSHOP: 'TEILEPORTAL',
  INSURANCE_PORTAL: 'HUK DASHBOARD'
}

export const USER_ROLES = {
  USER: 'user',
  SYSTEM_ADMIN: 'system_admin'
}

export const DEFAULT_PAGE_SIZE = 20
